import { withNamespaces } from "react-i18next";
import { FormGroup, Input, Spinner, Table } from "reactstrap";

const HandelsregisterResult = ({
    t,
    serviceQuery,
    searchColumns,
    service,
    companyData,
    toggleReport
}) => {
    return (
        <div
            style={{
                maxHeight: '400px',
                overflow: 'auto'
            }}
        >
            <Table bordered hover striped>
                <thead
                    style={{
                        position: 'sticky',
                        top: 0,
                        background: 'white',
                        zIndex: 2
                    }}
                >
                    <tr>
                        <th>
                            {t('Select')}
                        </th>
                        {searchColumns.map((col, colIndex) => (
                            <th key={colIndex}>
                                {t(col.title)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {serviceQuery.isFetching ? (
                        <tr>
                            <td colSpan={searchColumns.length + 1}>
                                <div className="text-center">
                                    <Spinner size="sm" color="primary" className="me-1" />
                                    {t('Fetching search results')}...
                                </div>
                            </td>
                        </tr>
                    ) : (
                        serviceQuery.data?.length > 0 ? (
                            (serviceQuery.data || []).map((org, orgIndex) => {
                                const entityId = org.entity_id || org.id;
                                const isSelected = companyData.reports[service.id]?.findIndex(
                                    (report) => report.id === entityId
                                ) > -1;

                                return (
                                    <tr key={entityId || orgIndex}>
                                        <th>
                                            <FormGroup check className="d-flex align-items-center">
                                                <Input
                                                    type="checkbox"
                                                    checked={isSelected}
                                                    onChange={() => toggleReport(service.id, {
                                                        ...org,
                                                        id: entityId
                                                    })}
                                                />
                                            </FormGroup>
                                        </th>
                                        {searchColumns.map((col, colIndex) => (
                                            <td key={colIndex}>
                                                {col.formatter
                                                    ? col.formatter(org[col.key], org, t)
                                                    : org[col.key]}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={searchColumns.length + 1}>
                                    <div className="text-center">
                                        {t('No results found')}
                                    </div>
                                </td>
                            </tr>
                        )
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default withNamespaces()(HandelsregisterResult);
